import useTurnover from '../../../hooks/useTurnover';
import { Table } from '../../Table';
import React from 'react';
import { TableStyle, TableTitle } from './style';
import { TableComponentProps } from '../types';
export function Turnover({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { onChange: onChange, tables } = useTurnover({
    data: funds[currentDataKey]?.fund_data?.TURNOVER,
    onChangeFund,
    schema: schema.TURNOVER,
    isStaticTemplate: isStaticTemplate ?? false,
    requiredFields: funds[currentDataKey]?.required_tables?.TURNOVER?.field_names || [],
    isMultiFunds: isMultiFunds ?? false,
    funds
  });

  return tables.map((table, index) => (
    <React.Fragment key={`${table.name}-${index}`}>
      <TableTitle id={`reporttables-turnover-title-${index + 1}`}>{table.name}:</TableTitle>
      <TableStyle id={`reporttables-turnover-group-${index + 1}`}>
        {table.tables.map((item, j) => (
          <div
            className="table-item"
            id={`reporttables-turnover-item-${index + 1}-${j + 1}`}
            key={`table-item-${index}-${j}-${table.name}`}
          >
            <Table
              id={`reporttables-turnover-table-${index + 1}-${j + 1}`}
              handleChanges={onChange}
              columns={item.columns}
              rows={item.rows}
              stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
            />
          </div>
        ))}
      </TableStyle>
    </React.Fragment>
  ));
}
